/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { BaseWorkPackageDto } from '../models/base-work-package-dto';
import { BaseWorkPackageDtoPage } from '../models/base-work-package-dto-page';
import { BytesResult } from '../models/bytes-result';
import { createWorkPackage } from '../fn/work-packages/create-work-package';
import { CreateWorkPackage$Params } from '../fn/work-packages/create-work-package';
import { createWorkPackageFromTemplate } from '../fn/work-packages/create-work-package-from-template';
import { CreateWorkPackageFromTemplate$Params } from '../fn/work-packages/create-work-package-from-template';
import { deleteWorkPackage } from '../fn/work-packages/delete-work-package';
import { DeleteWorkPackage$Params } from '../fn/work-packages/delete-work-package';
import { exportCsvWorkPackages } from '../fn/work-packages/export-csv-work-packages';
import { ExportCsvWorkPackages$Params } from '../fn/work-packages/export-csv-work-packages';
import { exportMultiplePdfWorkPackage } from '../fn/work-packages/export-multiple-pdf-work-package';
import { ExportMultiplePdfWorkPackage$Params } from '../fn/work-packages/export-multiple-pdf-work-package';
import { exportSinglePdfWorkPackage } from '../fn/work-packages/export-single-pdf-work-package';
import { ExportSinglePdfWorkPackage$Params } from '../fn/work-packages/export-single-pdf-work-package';
import { getWorkPackage } from '../fn/work-packages/get-work-package';
import { GetWorkPackage$Params } from '../fn/work-packages/get-work-package';
import { getWorkPackageDynamicForms } from '../fn/work-packages/get-work-package-dynamic-forms';
import { GetWorkPackageDynamicForms$Params } from '../fn/work-packages/get-work-package-dynamic-forms';
import { getWorkPackagesKPI } from '../fn/work-packages/get-work-packages-kpi';
import { GetWorkPackagesKPI$Params } from '../fn/work-packages/get-work-packages-kpi';
import { importCsvWorkPackages } from '../fn/work-packages/import-csv-work-packages';
import { ImportCsvWorkPackages$Params } from '../fn/work-packages/import-csv-work-packages';
import { listWorkPackages } from '../fn/work-packages/list-work-packages';
import { ListWorkPackages$Params } from '../fn/work-packages/list-work-packages';
import { takeOverWorkPackage } from '../fn/work-packages/take-over-work-package';
import { TakeOverWorkPackage$Params } from '../fn/work-packages/take-over-work-package';
import { updateWorkPackage } from '../fn/work-packages/update-work-package';
import { UpdateWorkPackage$Params } from '../fn/work-packages/update-work-package';
import { updateWorkPackageDynamicFormsSchema } from '../fn/work-packages/update-work-package-dynamic-forms-schema';
import { UpdateWorkPackageDynamicFormsSchema$Params } from '../fn/work-packages/update-work-package-dynamic-forms-schema';
import { updateWorkPackageDynamicFormsValue } from '../fn/work-packages/update-work-package-dynamic-forms-value';
import { UpdateWorkPackageDynamicFormsValue$Params } from '../fn/work-packages/update-work-package-dynamic-forms-value';
import { WorkPackageDynamicFormsDto } from '../models/work-package-dynamic-forms-dto';
import { WorkPackagesKpiDto } from '../models/work-packages-kpi-dto';

@Injectable({ providedIn: 'root' })
export class WorkPackagesApi extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `listWorkPackages()` */
  static readonly ListWorkPackagesPath = '/v0/workPackages';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `listWorkPackages()` instead.
   *
   * This method doesn't expect any request body.
   */
  listWorkPackages$Response(params?: ListWorkPackages$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseWorkPackageDtoPage>> {
    return listWorkPackages(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `listWorkPackages$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  listWorkPackages(params?: ListWorkPackages$Params, context?: HttpContext): Observable<BaseWorkPackageDtoPage> {
    return this.listWorkPackages$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseWorkPackageDtoPage>): BaseWorkPackageDtoPage => r.body)
    );
  }

  /** Path part for operation `createWorkPackage()` */
  static readonly CreateWorkPackagePath = '/v0/workPackages';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createWorkPackage()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createWorkPackage$Response(params: CreateWorkPackage$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseWorkPackageDto>> {
    return createWorkPackage(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createWorkPackage$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createWorkPackage(params: CreateWorkPackage$Params, context?: HttpContext): Observable<BaseWorkPackageDto> {
    return this.createWorkPackage$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseWorkPackageDto>): BaseWorkPackageDto => r.body)
    );
  }

  /** Path part for operation `getWorkPackage()` */
  static readonly GetWorkPackagePath = '/v0/workPackages/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getWorkPackage()` instead.
   *
   * This method doesn't expect any request body.
   */
  getWorkPackage$Response(params: GetWorkPackage$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseWorkPackageDto>> {
    return getWorkPackage(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getWorkPackage$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getWorkPackage(params: GetWorkPackage$Params, context?: HttpContext): Observable<BaseWorkPackageDto> {
    return this.getWorkPackage$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseWorkPackageDto>): BaseWorkPackageDto => r.body)
    );
  }

  /** Path part for operation `updateWorkPackage()` */
  static readonly UpdateWorkPackagePath = '/v0/workPackages/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateWorkPackage()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateWorkPackage$Response(params: UpdateWorkPackage$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return updateWorkPackage(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateWorkPackage$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateWorkPackage(params: UpdateWorkPackage$Params, context?: HttpContext): Observable<void> {
    return this.updateWorkPackage$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `deleteWorkPackage()` */
  static readonly DeleteWorkPackagePath = '/v0/workPackages/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteWorkPackage()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteWorkPackage$Response(params: DeleteWorkPackage$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return deleteWorkPackage(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteWorkPackage$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteWorkPackage(params: DeleteWorkPackage$Params, context?: HttpContext): Observable<void> {
    return this.deleteWorkPackage$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `getWorkPackageDynamicForms()` */
  static readonly GetWorkPackageDynamicFormsPath = '/v0/workPackages/{id}/dynamic-forms';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getWorkPackageDynamicForms()` instead.
   *
   * This method doesn't expect any request body.
   */
  getWorkPackageDynamicForms$Response(params: GetWorkPackageDynamicForms$Params, context?: HttpContext): Observable<StrictHttpResponse<WorkPackageDynamicFormsDto>> {
    return getWorkPackageDynamicForms(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getWorkPackageDynamicForms$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getWorkPackageDynamicForms(params: GetWorkPackageDynamicForms$Params, context?: HttpContext): Observable<WorkPackageDynamicFormsDto> {
    return this.getWorkPackageDynamicForms$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkPackageDynamicFormsDto>): WorkPackageDynamicFormsDto => r.body)
    );
  }

  /** Path part for operation `getWorkPackagesKpi()` */
  static readonly GetWorkPackagesKpiPath = '/v0/workPackages/kpi';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getWorkPackagesKPI()` instead.
   *
   * This method doesn't expect any request body.
   */
  getWorkPackagesKPI$Response(params?: GetWorkPackagesKPI$Params, context?: HttpContext): Observable<StrictHttpResponse<WorkPackagesKpiDto>> {
    return getWorkPackagesKPI(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getWorkPackagesKPI$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getWorkPackagesKPI(params?: GetWorkPackagesKPI$Params, context?: HttpContext): Observable<WorkPackagesKpiDto> {
    return this.getWorkPackagesKPI$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkPackagesKpiDto>): WorkPackagesKpiDto => r.body)
    );
  }

  /** Path part for operation `createWorkPackageFromTemplate()` */
  static readonly CreateWorkPackageFromTemplatePath = '/v0/workPackages/from-template';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createWorkPackageFromTemplate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createWorkPackageFromTemplate$Response(params: CreateWorkPackageFromTemplate$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseWorkPackageDto>> {
    return createWorkPackageFromTemplate(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createWorkPackageFromTemplate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createWorkPackageFromTemplate(params: CreateWorkPackageFromTemplate$Params, context?: HttpContext): Observable<BaseWorkPackageDto> {
    return this.createWorkPackageFromTemplate$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseWorkPackageDto>): BaseWorkPackageDto => r.body)
    );
  }

  /** Path part for operation `updateWorkPackageDynamicFormsSchema()` */
  static readonly UpdateWorkPackageDynamicFormsSchemaPath = '/v0/workPackages/{id}/dynamic-forms-schema';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateWorkPackageDynamicFormsSchema()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateWorkPackageDynamicFormsSchema$Response(params: UpdateWorkPackageDynamicFormsSchema$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return updateWorkPackageDynamicFormsSchema(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateWorkPackageDynamicFormsSchema$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateWorkPackageDynamicFormsSchema(params: UpdateWorkPackageDynamicFormsSchema$Params, context?: HttpContext): Observable<void> {
    return this.updateWorkPackageDynamicFormsSchema$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `updateWorkPackageDynamicFormsValue()` */
  static readonly UpdateWorkPackageDynamicFormsValuePath = '/v0/workPackages/{id}/dynamic-forms-value';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateWorkPackageDynamicFormsValue()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateWorkPackageDynamicFormsValue$Response(params: UpdateWorkPackageDynamicFormsValue$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return updateWorkPackageDynamicFormsValue(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateWorkPackageDynamicFormsValue$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateWorkPackageDynamicFormsValue(params: UpdateWorkPackageDynamicFormsValue$Params, context?: HttpContext): Observable<void> {
    return this.updateWorkPackageDynamicFormsValue$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `importCsvWorkPackages()` */
  static readonly ImportCsvWorkPackagesPath = '/v0/workPackages/import-csv';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `importCsvWorkPackages()` instead.
   *
   * This method sends `text/csv` and handles request body of type `text/csv`.
   */
  importCsvWorkPackages$Response(params: ImportCsvWorkPackages$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return importCsvWorkPackages(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `importCsvWorkPackages$Response()` instead.
   *
   * This method sends `text/csv` and handles request body of type `text/csv`.
   */
  importCsvWorkPackages(params: ImportCsvWorkPackages$Params, context?: HttpContext): Observable<void> {
    return this.importCsvWorkPackages$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `exportCsvWorkPackages()` */
  static readonly ExportCsvWorkPackagesPath = '/v0/workPackages/export-csv';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `exportCsvWorkPackages()` instead.
   *
   * This method doesn't expect any request body.
   */
  exportCsvWorkPackages$Response(params: ExportCsvWorkPackages$Params, context?: HttpContext): Observable<StrictHttpResponse<string>> {
    return exportCsvWorkPackages(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `exportCsvWorkPackages$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  exportCsvWorkPackages(params: ExportCsvWorkPackages$Params, context?: HttpContext): Observable<string> {
    return this.exportCsvWorkPackages$Response(params, context).pipe(
      map((r: StrictHttpResponse<string>): string => r.body)
    );
  }

  /** Path part for operation `exportSinglePdfWorkPackage()` */
  static readonly ExportSinglePdfWorkPackagePath = '/v0/workPackages/{id}/export-pdf';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `exportSinglePdfWorkPackage()` instead.
   *
   * This method doesn't expect any request body.
   */
  exportSinglePdfWorkPackage$Response(params: ExportSinglePdfWorkPackage$Params, context?: HttpContext): Observable<StrictHttpResponse<BytesResult>> {
    return exportSinglePdfWorkPackage(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `exportSinglePdfWorkPackage$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  exportSinglePdfWorkPackage(params: ExportSinglePdfWorkPackage$Params, context?: HttpContext): Observable<BytesResult> {
    return this.exportSinglePdfWorkPackage$Response(params, context).pipe(
      map((r: StrictHttpResponse<BytesResult>): BytesResult => r.body)
    );
  }

  /** Path part for operation `exportMultiplePdfWorkPackage()` */
  static readonly ExportMultiplePdfWorkPackagePath = '/v0/workPackages/export-pdf';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `exportMultiplePdfWorkPackage()` instead.
   *
   * This method doesn't expect any request body.
   */
  exportMultiplePdfWorkPackage$Response(params: ExportMultiplePdfWorkPackage$Params, context?: HttpContext): Observable<StrictHttpResponse<BytesResult>> {
    return exportMultiplePdfWorkPackage(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `exportMultiplePdfWorkPackage$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  exportMultiplePdfWorkPackage(params: ExportMultiplePdfWorkPackage$Params, context?: HttpContext): Observable<BytesResult> {
    return this.exportMultiplePdfWorkPackage$Response(params, context).pipe(
      map((r: StrictHttpResponse<BytesResult>): BytesResult => r.body)
    );
  }

  /** Path part for operation `takeOverWorkPackage()` */
  static readonly TakeOverWorkPackagePath = '/v0/workPackages/{id}/takeover';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `takeOverWorkPackage()` instead.
   *
   * This method doesn't expect any request body.
   */
  takeOverWorkPackage$Response(params: TakeOverWorkPackage$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return takeOverWorkPackage(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `takeOverWorkPackage$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  takeOverWorkPackage(params: TakeOverWorkPackage$Params, context?: HttpContext): Observable<void> {
    return this.takeOverWorkPackage$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
